function toHex(buffer) {
  const bytes = new Uint8Array(buffer)
  let hex = ''
  for (const byte of bytes) {
    hex += byte.toString(16).padStart(2, '0')
  }
  return hex
}

function hasApkExtension(filename = '') {
  return String(filename).trim().toLowerCase().endsWith('.apk')
}

export async function computeFileSha256(file, options = {}) {
  if (!(file instanceof File)) {
    throw new Error('File is required')
  }

  if (file.size <= 0) {
    throw new Error('File is empty')
  }

  const maxBytes = Number(options.maxBytes || 512 * 1024 * 1024)
  if (Number.isFinite(maxBytes) && maxBytes > 0 && file.size > maxBytes) {
    throw new Error(`File is too large for in-browser hashing (${file.size} bytes)`)
  }

  const warnings = []
  if (!hasApkExtension(file.name)) {
    warnings.push('File extension is not .apk')
  }

  const subtle = globalThis.crypto?.subtle
  if (!subtle) {
    throw new Error('Web Crypto API is not available')
  }

  const buffer = await file.arrayBuffer()
  const digest = await subtle.digest('SHA-256', buffer)

  return {
    sha256: toHex(digest).toLowerCase(),
    warnings,
  }
}

export function isValidSha256(value) {
  return /^[a-f0-9]{64}$/i.test(String(value || '').trim())
}

export default {
  computeFileSha256,
  isValidSha256,
}
